module.exports = __webpack_public_path__ + "img/dianjiyun2.3fc559f0.png";